import { Setting } from '../../types/Settings';
import GridAction from '../../components/common/GridAction';
import { AppPermissions } from '../../constants/Permissions';

function isNumber(value: any): value is number {
  return typeof value === 'number' && !isNaN(value);
}
function isBoolean(value: any): value is boolean {
  return typeof value === 'boolean';
}

export const makeSettingListColumn = (onDeleted: (id: string) => void, onEdit: (setting: Setting) => void) => {
  const col = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const { id, scope } = row.original as Setting;
        if (scope === 'STATIC') return ''; // dont need to edit static
        return (
          <GridAction
            onEdit={onEdit}
            onDeleted={onDeleted}
            editPermission={AppPermissions.Setting.Manage}
            deletePermission={AppPermissions.Setting.Manage}
            row={row.original}
            id={id}
          />
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 250,
    },
    {
      header: 'Scope',
      accessorKey: 'scope',
      enableColumnFilter: true,
      size: 200,
    },
    {
      header: 'Value',
      accessorKey: 'value',
      cell: ({ row }) => {
        const { value } = row.original;
        if (isNumber(value)) {
          return value;
        } else if (isBoolean(value)) {
          return value ? 'true' : 'false';
        } else if (Array.isArray(value)) {
          return (
            <p>
              {value.map((data, index) => (
                <span key={index}>
                  {`${data.text} = ${data.value}`}
                  <br />
                </span>
              ))}
            </p>
          );
        } else if (typeof value === 'object' && value !== null) {
          return <pre>{JSON.stringify(value, null, 2)}</pre>;
        }
        return value;
      },
    },
  ] as Array<any>;

  return col;
};
